import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  InputGroup,
  Select,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import axios from "axios";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
function App() {
  const tanggal_sekarang1 = new Date().toLocaleDateString("en-GB", {timeZone:'Asia/Jakarta'});
  
  // Mengubah format tanggal sekarang ke format yang sesuai
  const [day1, month1, year1] = tanggal_sekarang1.split("/");
  const formatted_tanggal_sekarang1 = `${year1}-${month1}-${day1}`;
  const [formData, setFormData] = useState({
    timestamp: formatted_tanggal_sekarang1,
    email: "",
    confirm_email: "",
    company_name: "",
    company_type: "",
    departement: "",
    job_level: "",
    country: "",
    city: "",
    website: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    job_title: "",
    how_you_know: "",
    A_1: "",
    A_2: "",
  });
  const [loading, setLoading] = useState(false);
  const [emailConfirmationError, setEmailConfirmationError] = useState("");
  const [errorEmailPrefix1, setErrorEmailPrefix1] = useState("");
  const [errorEmailPrefix2, setErrorEmailPrefix2] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [data_mulai, setData_mulai] = useState("");
  const [data_tutup, setData_tutup] = useState("");
  const [isClosed,setIsClosed] = useState("");


  const companyTypeOptions = [
    {
      value: "Components/Accessories/Services",
      label: "Components/Accessories/Services",
    },
    { value: "Aftermarket", label: "Aftermarket" },
    { value: "ITS", label: "ITS" },
    { value: "OTA/Booking platform", label: "OTA/Booking platform" },
    { value: "Vehicle manufacturer", label: "Vehicle manufacturer" },
    {
      value: "Vehicle dealer/distributor",
      label: "Vehicle dealer/distributor",
    },
    { value: "Operator bus/coach", label: "Operator bus/coach" },
    { value: "Federation/Association", label: "Federation/Association" },
    { value: "Authorities", label: "Authorities" },
    { value: "Governmental organization", label: "Governmental organization" },
    {
      value: "Non-governmental organization",
      label: "Non-governmental organization",
    },
    { value: "Schools/Research", label: "Schools/Research" },
    { value: "Consultancy", label: "Consultancy" },
    { value: "Finance", label: "Finance" },
    { value: "Tourism", label: "Tourism" },
    { value: "Trade press bus & coach", label: "Trade press bus & coach" },
    { value: "Public press", label: "Public press" },
    { value: "PR agency", label: "PR agency" },
    { value: "Exhibitor press", label: "Exhibitor press" },
    { value: "Exhibition organizer", label: "Exhibition organizer" },
    { value: "Other", label: "Other" },
  ];

  const countryOptions = [
    "Afghanistan",
    "Åland Islands",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia (Plurinational State of)",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "United States Minor Outlying Islands",
    "Virgin Islands (British)",
    "Virgin Islands (U.S.)",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cabo Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo (Democratic Republic of the)",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Vatican City",
    "Honduras",
    "Hungary",
    "Hong Kong",
    "Iceland",
    "India",
    "Indonesia",
    "Ivory Coast",
    "Iran (Islamic Republic of)",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "North Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia (Federated States of)",
    "Moldova (Republic of)",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Korea (Democratic People's Republic of)",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine, State of",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of Kosovo",
    "Réunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin (French part)",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "Korea (Republic of)",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "South Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom of Great Britain and Northern Ireland",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela (Bolivarian Republic of)",
    "Vietnam",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const howKnowOptions = [
    "Busworld website",
    "Other website",
    "Someone told me / invited me",
    "E-mail",
    "Social Media (Facebook, LinkedIn, Instagram, Twitter)",
    "Search Engine (Google, Bing, Baidu, etc.)",
    "Magazine",
    "SMS / WhatsApp",
  ];


  


const call = async() =>{
  
  await axios
  .get("https://api.webinar-registration.inamarine-exhibition.com/api/data")
  .then((response) => {
      setData_mulai(response.data.data_mulai);
      setData_tutup(response.data.data_tutup);
      setLoading(false); // Set loading to false after getting the response
    })
    .catch((error) => {
      console.error(error);
      setLoading(false); // Set loading to false if there's an error
    });
}
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    // Update state based on input type
    if (type === "checkbox") {
      setFormData({
        ...formData,
        [id]: checked ? "1" : "0", // Set '1' if checked, '0' if unchecked
      });
    } else if (id === "website") {
      // Menambahkan prefix "https://" jika tidak sudah memiliki
      const prefixedValue = value.startsWith("https://")
        ? value
        : `https://${value}`;
      setFormData({
        ...formData,
        [id]: prefixedValue,
      });
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
   
    // Validasi Email
    if (!formData.email.includes("@")) {
      console.error("Email is not valid");
      setErrorEmailPrefix1("Email must contain an @ symbol");
    } else {
      setErrorEmailPrefix1("");
    }

    // Validasi Confirm Email
    if (!formData.confirm_email.includes("@")) {
      setErrorEmailPrefix2("Email must contain an @ symbol");
    } else {
      setErrorEmailPrefix2("");
    }

    // Validasi Kedua Email Cocok
    if (formData.email !== formData.confirm_email) {
      setEmailConfirmationError("Email and confirmation emails do not match.");
    } else {
      setEmailConfirmationError("");
    }

    // Validasi Nomor Telepon
    if (!formData.phone_number.startsWith("62")) {
      console.error("Phone number is not valid");
      setPhoneError("The phone number must begin with the prefix code '62'.");
    } else {
      setPhoneError("");
    }

    // Jika Semua Validasi Berhasil
    if (
      formData.phone_number.startsWith("62") &&
      formData.email === formData.confirm_email &&
      formData.confirm_email.includes("@") &&
      formData.email.includes("@")
    ) {
      try {
        setLoading(true);
        setFormData({
          timestamp: new Date().toLocaleDateString("en-GB", {timeZone:'Asia/Jakarta'}),
        });
        const response = await axios.post(
          "https://api.webinar-registration.inamarine-exhibition.com/store_webinar_registration",
          // "http://localhost:3000/store_webinar_registration",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 201) {
          console.log("Registrasi berhasil disimpan");

          swal({
            title: "Pendaftaran Berhasil!",
            text:
              "Terima kasih atas pendaftarannya.\n\n" +
              "Sebuah email telah dikirimkan ke Anda.\n" +
              "Harap cetak atau tunjukkan email konfirmasi bersama dengan kartu bisnis Anda untuk mengambil badge di salah satu loket Pendaftaran Pra-online Pengunjung atau counter cetak sendiri.\n\n" +
              "Harap periksa inbox/spam folder Anda untuk menerima email konfirmasi.\n" +
              "Jika Anda tidak menerima surat konfirmasi, hubungi staf kami:\n" +
              "gem.marketing02@gmail.com\n\n" +
              "Kami menantikan kedatangan Anda di Busworld Southeast Asia\n\n" +
              "Tim Busworld Southeast Asia",
            icon: "success",
            buttons: true,
          });
          setLoading(false);
          
        } else {
          console.error("Gagal menyimpan registrasi");

          swal({
            title: "Masalah Basis Data!",
            text: "Gagal menyimpan data",
            icon: "error",
            buttons: false,
            timer: 4000,
          });
          setLoading(false);
          
        }
      } catch (error) {
        console.error("Terjadi kesalahan:", error.response.data.error);

        swal({
          title: "Kesalahan Sistem!",
          text:
            "Terjadi kesalahan!: " +
            error.response.data.error +
            "\n \r" +
            "Catatan: harap isi bidang secara manual/tidak menggunakan pengisian otomatis",
          icon: "error",
          buttons: false,
          timer: 4000,
        });

        setFormData({
          timestamp: formatted_tanggal_sekarang1,
          email: "",
          confirm_email: "",
          company_name: "",
          company_type: "",
          departement: "",
          job_level: "",
          country: "",
          city: "",
          website: "",
          first_name: "",
          last_name: "",
          phone_number: "",
          job_title: "",
          how_you_know: "",
          A_1: "",
          A_2: "",
        });
        setLoading(false);
        
      }
    }
  };


  
  
  useEffect(()=>{

    setLoading(true);
    
    call();
    
  const tanggal_tutup = data_tutup; // Hanya tanggal tanpa waktu
  const options = { timeZone: 'Asia/Jakarta' };
  const tanggal_sekarang = new Date().toLocaleDateString("en-GB", options);
  
  // Mengubah format tanggal sekarang ke format yang sesuai
  const [day, month, year] = tanggal_sekarang.split("/");
  const formatted_tanggal_sekarang = `${day}-${month}-${year}`;
  
  // // Kondisi isClosed
  setIsClosed(formatted_tanggal_sekarang < tanggal_tutup);
  // const isClosed = true;
  console.log(isClosed);
  console.log(data_mulai);

},[data_mulai,data_tutup]);
  



  return (
    <div
      className="App"
      style={{ display: "flex", justifyContent: "center", margin: "100px 0" }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "-5%",
            width: "100%",
            height: "100%",
            zIndex: "1000",
          }}
        >
          <Spinner animation="grow" style={{ width: "50px", height: "50px" }} />
        </div>
      )}
      <Container
        style={{
          backgroundColor: "#fafafa",
          width: "50%",
          paddingBottom: "50px",
          paddingLeft: "0",
          paddingRight: "0",
        }}
      >
        <Row>
          <Col>
            <div className="banner" style={{ padding: "0px 0px" }}>
              <img
                src="https://live.staticflickr.com/65535/53450712904_fac07a15ac_h.jpg"
                style={{ width: "100%" }}
              />
            </div>
            {isClosed ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    paddingTop: "20px",
                    paddingLeft: "45px",
                    fontSize: "x-large",
                    fontWeight: "bold",
                  }}
                >
                  Webinar on begin {data_mulai}
                </div>
                <Form className="p-5">
                  {/* Company Name */}
                  <Form.Group as={Row} id="companyName" className="mb-3">
                    <Form.Label column md={5} style={{ textAlign: "left" }}>
                      <div>Company Name</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>

                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.company_name}
                        required
                        type="text"
                        placeholder="Nama Perusahaan"
                        onChange={handleInputChange}
                        id="company_name"
                      />
                    </Col>
                  </Form.Group>
              
                  {/* Company Type */}
                  <Form.Group
                    as={Row}
                    id="companyType"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Company Type</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Select
                        required
                        aria-label="Default select example"
                        onChange={handleInputChange}
                        id="company_type"
                        value={formData.company_type}
                      >
                        <option
                          selected
                          disabled
                          data-is-placeholder="true"
                          value=""
                        >
                          ==Select==
                        </option>
                        {companyTypeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>

                  {/* Departement */}
                  <Form.Group as={Row} id="departement" className="mb-3">
                    <Form.Label column md={5} style={{ textAlign: "left" }}>
                      <div> Departement</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.departement}
                        required
                        type="text"
                        placeholder="departement"
                        onChange={handleInputChange}
                        id="departement"
                      />
                    </Col>
                  </Form.Group>

                  {/* Job Level */}
                  <Form.Group as={Row} id="job_level" className="mb-3">
                    <Form.Label column md={5} style={{ textAlign: "left" }}>
                      <div> Job Level</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.job_level}
                        required
                        type="text"
                        placeholder="job_level"
                        onChange={handleInputChange}
                        id="job_level"
                      />
                    </Col>
                  </Form.Group>

                  {/* Country */}
                  <Form.Group
                    as={Row}
                    id="country"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Country</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Select
                        value={formData.country}
                        required
                        as="select"
                        onChange={handleInputChange}
                        id="country"
                      >
                        <option
                          selected
                          disabled
                          data-is-placeholder="true"
                          value=""
                        >
                          ==Select==
                        </option>
                        {countryOptions.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>

                  {/* City */}
                  <Form.Group
                    as={Row}
                    id="city"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> City</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.city}
                        required
                        type="text"
                        placeholder="Kota"
                        onChange={handleInputChange}
                        id="city"
                      />
                    </Col>
                  </Form.Group>

                  {/* Website */}
                  <Form.Group
                    as={Row}
                    id="website"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      Website
                    </Form.Label>

                    <Col md={7}>
                      <InputGroup>
                        <Form.Control
                          autoCorrect="off"
                          aria-autocomplete="off"
                          autoComplete="off"
                          required
                          type="text"
                          value={formData.website}
                          placeholder="Domain"
                          onChange={handleInputChange}
                          id="website"
                        />
                      </InputGroup>
                    </Col>
                  </Form.Group>

                  {/* First Name */}
                  <Form.Group
                    as={Row}
                    id="firstName"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> First Name</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.first_name}
                        required
                        type="text"
                        placeholder="Nama Depan"
                        onChange={handleInputChange}
                        id="first_name"
                      />
                    </Col>
                  </Form.Group>

                  {/* Last Name */}
                  <Form.Group
                    as={Row}
                    id="lastName"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Last Name</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.last_name}
                        required
                        type="text"
                        placeholder="Nama Belakang"
                        onChange={handleInputChange}
                        id="last_name"
                      />
                    </Col>
                  </Form.Group>

                  {/* Email Address */}
                  <Form.Group
                    as={Row}
                    id="email"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Email Address</div>
                      {"\r\n"}

                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        required
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Alamat Email"
                        id="email"
                      />
                      {errorEmailPrefix1 && (
                        <div>
                          {"\r \n"}
                          <Form.Text className="text-danger">
                            {errorEmailPrefix1}
                          </Form.Text>
                        </div>
                      )}
                    </Col>
                  </Form.Group>

                  {/* Confirmation Email */}
                  <Form.Group
                    as={Row}
                    id="confirmEmail"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Confirmation Email </div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.confirm_email}
                        required
                        type="email"
                        onChange={handleInputChange}
                        placeholder="Konfirmasi Email"
                        id="confirm_email"
                      />
                      {emailConfirmationError && (
                        <div>
                          {"\r\n"}

                          <Form.Text className="text-danger">
                            {emailConfirmationError}
                          </Form.Text>
                        </div>
                      )}
                      {errorEmailPrefix2 && (
                        <div>
                          {"\r \n"}
                          <Form.Text className="text-danger">
                            {errorEmailPrefix2}
                          </Form.Text>
                        </div>
                      )}
                    </Col>
                  </Form.Group>

                  {/* Phone Number */}
                  <Form.Group
                    as={Row}
                    id="phoneNumber"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Phone Number</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <InputGroup>
                        <Form.Control
                          autoCorrect="off"
                          aria-autocomplete="off"
                          autoComplete="off"
                          value={formData.phone_number}
                          required
                          type="number"
                          placeholder="Require international prefix e.g. +62xxx"
                          onChange={handleInputChange}
                          id="phone_number"
                        />
                      </InputGroup>
                      {phoneError && (
                        <div>
                          {"\r\n"}

                          <Form.Text className="text-danger">
                            {phoneError}
                          </Form.Text>
                        </div>
                      )}
                    </Col>
                  </Form.Group>

                  {/* Job Title */}
                  <Form.Group
                    as={Row}
                    id="jobTitle"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> Job Title</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Control
                        autoCorrect="off"
                        aria-autocomplete="off"
                        autoComplete="off"
                        value={formData.job_title}
                        required
                        type="text"
                        placeholder="Jabatan"
                        onChange={handleInputChange}
                        id="job_title"
                      />
                    </Col>
                  </Form.Group>

                  {/* How do you know Busworld? */}
                  <Form.Group
                    as={Row}
                    id="howYouKnow"
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <Form.Label column md={5}>
                      <div> How do you know Busworld?</div>
                      {"\r\n"}
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Form.Label>
                    <Col md={7}>
                      <Form.Select
                        value={formData.how_you_know}
                        required
                        onChange={handleInputChange}
                        id="how_you_know"
                      >
                        <option
                          selected
                          disabled
                          data-is-placeholder="true"
                          value=""
                        >
                          ==Select==
                        </option>
                        {howKnowOptions.map((option) => (
                          <option
                            key={option}
                            className="formkit-option"
                            value={option}
                          >
                            {option}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>

                  <Form.Group
                    as={Row}
                    className="mb-3 align-items-center"
                    style={{ textAlign: "left" }}
                  >
                    <Col md={1} style={{ width: "15px" }}>
                      <Form.Check
                        defaultChecked={false}
                        onChange={handleInputChange}
                        id="A_1"
                      />
                    </Col>
                    <Col md={11}>
                      <Form.Label>
                        Accompanying info: Our newsletter includes the latest
                        bus and coach industry news from around the globe in
                        English, as well as the latest Busworld event news.
                      </Form.Label>
                      <Form.Text>
                        I want to receive the Busworld Business newsletter in
                        the future / Saya ingin menerima buletin Busworld
                        Business.
                      </Form.Text>
                    </Col>
                  </Form.Group>

                  <Form.Group
                    as={Row}
                    className="mb-3 align-items-center"
                    style={{ textAlign: "left" }}
                  >
                    <Col md={1} style={{ width: "15px" }}>
                      <Form.Check
                        defaultChecked={false}
                        required
                        onChange={handleInputChange}
                        id="A_2"
                      />
                    </Col>
                    <Col md={11}>
                      <Form.Label>
                        Accompanying info: Privacy Policy: By submitting your
                        details you allow Busworld and all its partners to store
                        your information and send you communication regarding
                        Busworld events. Your personal information will be
                        safely stored in our database. Your information will not
                        be shared, and you can unsubscribe at any time from our
                        communications. Click to read our Privacy Policy.
                      </Form.Label>
                      <Form.Text>
                        I agree to the Busworld privacy policy / Saya setuju
                        dengan kebijakan Busworld.
                      </Form.Text>
                      <div></div>
                      <Form.Text className="text-danger">
                        required field
                      </Form.Text>
                    </Col>
                  </Form.Group>

                  <Form.Group
                    as={Row}
                    className="mb-3"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://www.busworldsoutheastasia.org/en/busworld-baav-privacy-policy">
                      https://www.busworldsoutheastasia.org/en/busworld-baav-privacy-policy
                    </a>
                  </Form.Group>

                  {/* Submit Button */}
                  <Form.Group as={Row}>
                    <Col md={{ span: 1, offset: 0 }}>
                      <Button onClick={handleFormSubmit} type="submit">
                        Register
                      </Button>
                    </Col>
                  </Form.Group>
                </Form>
              </>
            ):(
              <div>CLOSE </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
